import {
  FlyerDetailAddPageActions,
  FlyerDetailAddPageActionType,
} from "./flyer-detail-add-page.actions";
import { FlyerDetailAddPageState } from "../types/flyer-detail-add-page-state/flyer-detail-add-page-state.interface";
import { createFlyerDetailAddPageState } from "../types/flyer-detail-add-page-state/flyer-detail-add-page-state.functions";

export function flyerDetailAddPageReducer(
  state = createFlyerDetailAddPageState(),
  action: FlyerDetailAddPageActionType
): FlyerDetailAddPageState {
  switch (action.type) {
    case FlyerDetailAddPageActions.FetchTemplates:
    case FlyerDetailAddPageActions.CreatePage:
      return {
        ...state,
        isLoading: true,
      };
    case FlyerDetailAddPageActions.FetchTemplatesSuccess:
      return {
        ...state,
        isLoading: false,
        templates: action.payload,
      };
    case FlyerDetailAddPageActions.CreatePageSuccess:
      return createFlyerDetailAddPageState();
    default:
      return state;
  }
}
